import React from "react";
import Breadcrumb from "../../../Components/Common/Breadcrumb";
import Tabs from "../../../Components/Common/Tabs";
import { freeMaterialsTabsData } from "../../../data/SidebarData";
import StaticPageForm from "../../../Components/Common/Forms/StaticPageForm";
import useSWR from "swr";
import { TestApiUrls } from "../../../Api/Auth/ApiUrls";

const MechanicalFeModelTest = () => {
  const { data } = useSWR(TestApiUrls.list(""));

  return (
    <div>
      <Breadcrumb actionButtons={[]} />
      <Tabs tabs={freeMaterialsTabsData} />
      <StaticPageForm
        title="Mechanical Free FE Model Test"
        typeData={data}
        category={"mechanical"}
      />
    </div>
  );
};

export default MechanicalFeModelTest;
